"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _hasInterface = _interopRequireDefault(require("../../../../hasInterface"));

var _Collection = _interopRequireDefault(require("../../../../java/util/Collection"));

var _Coordinate = _interopRequireDefault(require("./Coordinate"));

var _ArrayList2 = _interopRequireDefault(require("../../../../java/util/ArrayList"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var CoordinateList =
/*#__PURE__*/
function (_ArrayList) {
  _inherits(CoordinateList, _ArrayList);

  function CoordinateList() {
    var _this;

    _classCallCheck(this, CoordinateList);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CoordinateList).call(this));
    CoordinateList.constructor_.apply(_assertThisInitialized(_this), arguments);
    return _this;
  }

  _createClass(CoordinateList, [{
    key: "getCoordinate",
    value: function getCoordinate(i) {
      return this.get(i);
    }
  }, {
    key: "addAll",
    value: function addAll() {
      if (arguments.length === 2 && typeof arguments[1] === "boolean" && (0, _hasInterface.default)(arguments[0], _Collection.default)) {
        var coll = arguments[0],
            allowRepeated = arguments[1];
        var isChanged = false;

        for (var i = coll.iterator(); i.hasNext();) {
          this.add(i.next(), allowRepeated);
          isChanged = true;
        }

        return isChanged;
      } else return _get(_getPrototypeOf(CoordinateList.prototype), "addAll", this).apply(this, arguments);
    }
  }, {
    key: "clone",
    value: function clone() {
      var clone = _get(_getPrototypeOf(CoordinateList.prototype), "clone", this).call(this);

      for (var i = 0; i < this.size(); i++) {
        clone.add(i, this.get(i).clone());
      }

      return clone;
    }
  }, {
    key: "toCoordinateArray",
    value: function toCoordinateArray() {
      return this.toArray(CoordinateList.coordArrayType);
    }
  }, {
    key: "add",
    value: function add() {
      if (arguments.length === 1) {
        var coord = arguments[0];

        _get(_getPrototypeOf(CoordinateList.prototype), "add", this).call(this, coord);
      } else if (arguments.length === 2) {
        if (arguments[0] instanceof Array && typeof arguments[1] === "boolean") {
          var _coord = arguments[0],
              allowRepeated = arguments[1];
          this.add(_coord, allowRepeated, true);
          return true;
        } else if (arguments[0] instanceof _Coordinate.default && typeof arguments[1] === "boolean") {
          var _coord2 = arguments[0],
              _allowRepeated = arguments[1];

          if (!_allowRepeated) {
            if (this.size() >= 1) {
              var last = this.get(this.size() - 1);
              if (last.equals2D(_coord2)) return null;
            }
          }

          _get(_getPrototypeOf(CoordinateList.prototype), "add", this).call(this, _coord2);
        } else if (arguments[0] instanceof Object && typeof arguments[1] === "boolean") {
          var obj = arguments[0],
              _allowRepeated2 = arguments[1];
          this.add(obj, _allowRepeated2);
          return true;
        }
      } else if (arguments.length === 3) {
        if (typeof arguments[2] === "boolean" && arguments[0] instanceof Array && typeof arguments[1] === "boolean") {
          var _coord3 = arguments[0],
              _allowRepeated3 = arguments[1],
              direction = arguments[2];

          if (direction) {
            for (var i = 0; i < _coord3.length; i++) {
              this.add(_coord3[i], _allowRepeated3);
            }
          } else {
            for (var i = _coord3.length - 1; i >= 0; i--) {
              this.add(_coord3[i], _allowRepeated3);
            }
          }

          return true;
        } else if (typeof arguments[2] === "boolean" && Number.isInteger(arguments[0]) && arguments[1] instanceof _Coordinate.default) {
          var _i = arguments[0],
              _coord4 = arguments[1],
              _allowRepeated4 = arguments[2];

          if (!_allowRepeated4) {
            var size = this.size();

            if (size > 0) {
              if (_i > 0) {
                var prev = this.get(_i - 1);
                if (prev.equals2D(_coord4)) return null;
              }

              if (_i < size) {
                var next = this.get(_i);
                if (next.equals2D(_coord4)) return null;
              }
            }
          }

          _get(_getPrototypeOf(CoordinateList.prototype), "add", this).call(this, _i, _coord4);
        }
      } else if (arguments.length === 4) {
        var _coord5 = arguments[0],
            _allowRepeated5 = arguments[1],
            start = arguments[2],
            end = arguments[3];
        var inc = 1;
        if (start > end) inc = -1;

        for (var i = start; i !== end; i += inc) {
          this.add(_coord5[i], _allowRepeated5);
        }

        return true;
      }
    }
  }, {
    key: "closeRing",
    value: function closeRing() {
      if (this.size() > 0) this.add(new _Coordinate.default(this.get(0)), false);
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return CoordinateList;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);

  return CoordinateList;
}(_ArrayList2.default);

exports.default = CoordinateList;

CoordinateList.constructor_ = function () {
  if (arguments.length === 0) {} else if (arguments.length === 1) {
    var coord = arguments[0];
    this.ensureCapacity(coord.length);
    this.add(coord, true);
  } else if (arguments.length === 2) {
    var _coord6 = arguments[0],
        allowRepeated = arguments[1];
    this.ensureCapacity(_coord6.length);
    this.add(_coord6, allowRepeated);
  }
};

CoordinateList.coordArrayType = new Array(0).fill(null);